import cookies from 'js-cookie';

/*
 * 참고 : https://gist.github.com/joduplessis/7b3b4340353760e945f972a69e855d11
 * General utils for managing cookies in Typescript.
 */
export function setCookie(name: string, value: string, expireDate?: Date): void {
  let cookie = `${name}=${value}; path=/ `;
  if (expireDate != undefined) {
    cookie += `;expires= ${expireDate.toUTCString()};`;
  }

  document.cookie = cookie;
}

export function getCookie(name: string): string | null {
  return cookies.get(name) ?? null;
}

export function deleteCookie(name: string): void {
  const date = new Date();

  // Set it expire in -1 days
  date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);

  // Set it
  document.cookie = name + '=; expires=' + date.toUTCString() + '; path=/';
}
